module.exports = {"id":"dp2_1l1q4","text":"Interacting Through Digital Technologies","instructions":"Which statement best describes a virtual assistant or chatbot?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l1q4-a1","text":"Software that responds to user input","score":1.8},{"id":"dp2_1l1q4-a2","text":"A human moderating online chat","score":0},{"id":"dp2_1l1q4-a3","text":"A physical device with emotions","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l1q4.json
// module id = 989
// module chunks = 41